export function changeWindowWidth(newWidth){
    return{
        type: 'CHANGE_WINDOW_WIDTH',
        payload: newWidth
    }
}

export function changeWindowHeight(newHeight){
    return{
        type: 'CHANGE_WINDOW_HEIGHT',
        payload: newHeight
    }
}



// WEBPACK FOOTER //
// ./src/redux/ReduxActions/WindowDimensionActions.js